import { createTheme } from '@mui/material';


import { defaultTheme } from './default-theme';
import { DefaultTheme } from '@types';

const darkTheme = createTheme(defaultTheme) as DefaultTheme;

export { darkTheme };
